<template>
<div>
    <div v-if="step.type == 'heading'" class="heading-label">{{step.title}}</div>
    <div v-if="step.type == 'task'" class="new-item-label">
        {{step.title}}
        <div class="description-text" v-if="step.description && !step.expanded">{{step.description}}</div>
    </div>
    <v-text-field v-if="step.type == 'text'" :value="step.value" @change="updateValue" :label="step.title" hide-details style="max-width:400px;"/>
    <v-switch v-if="step.type == 'true-false/switch'" color="blue" :value="step.value" @change="updateValue" :label="step.title" hide-details style="max-width:400px"/>
    <v-checkbox v-if="step.type == 'true-false/checkbox'" color="blue" :value="step.value" @change="updateValue" :label="step.title" hide-details style="max-width:400px"/>
    <FileUpload v-if="step.type == 'file/upload'" :step="step"/>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import FileUpload from './controls/FileUpload'

export default {
    data() {
        return {
        
        }
    },

    components: {
        FileUpload,
    },
    
    props: {
        step: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        updateValue(val) {
            
            this.step.value = val
            
        },
    },

    created() {

    }
}
</script>

<style scoped>
    .description-text {
        font-size:13px;
        color: #999;
    }
    .new-item-label {
        padding:5px;
       
        display:inline-block;
        /* min-width:200px; */
        width:auto; max-width:600px;
        cursor: pointer;
    }   

    .v-input--switch {
        margin-top:2px!important;
    }
    .v-input--checkbox {
        margin-top:0!important;
        /* padding:0px!important; */
    }
</style>




// WEBPACK FOOTER //
// StepSelector.vue?6c6a0ab3